<app-layout>
	<router-outlet></router-outlet>
</app-layout>
